'use strict';var _dec,_desc,_value,_class;function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key]});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=!0}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=void 0}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null}return desc}

const _=require('pulsar-utils/dist-es6/_');
const BaseController=require('../../../../../dist-es6/client/angularCommon/baseController');
const HandleUncaughtErrors=require('../../../../../dist-es6/client/services/uncaughtErrorHandler').Annotations.HandleUncaughtErrors;
const ModalSubmissionResult=require('../../../../../dist-es6/client/angularCommon/modalSubmissionResult');
const SocketResponse=require('../../../../../dist-es6/client/dtos/socketResponse');let

DeleteGroupModalController=(_dec=
























HandleUncaughtErrors(ModalSubmissionResult.FromError),(_class=class DeleteGroupModalController extends BaseController{static get $inject(){return['$modalInstance','resolvedParameters','uncaughtErrorHandler','uiCommandFactory','socketService','groupUpdateErrorHandlingService']}constructor($modalInstance,resolvedParameters,uncaughtErrorHandler,uiCommandFactory,socketService,groupUpdateErrorHandlingService){super(uncaughtErrorHandler);this._$modalInstance=$modalInstance;this._group=resolvedParameters.group;this._onGroupDeleted=resolvedParameters.onGroupDeleted;this._socketService=socketService;this._groupUpdateErrorHandlingService=groupUpdateErrorHandlingService;this._deleteGroupCommand=uiCommandFactory.makeForModal($modalInstance,this._deleteGroup.bind(this));this._deleteErrors=[]}get deleteGroupCommand(){return this._deleteGroupCommand}get deleteErrors(){return this._deleteErrors}
async _deleteGroup(){
this._deleteErrors=[];

const response=await this._socketService.sendAndWaitForResponse('DeleteGroup',{groupId:this._group.id});

if(!SocketResponse.succeeded(response)){
this._groupUpdateErrorHandlingService.handle(response);
}

await this._onGroupDeleted(this._group.id);

return ModalSubmissionResult.Close();
}

onCancel(){
this._$modalInstance.dismiss();
}},(_applyDecoratedDescriptor(_class.prototype,'_deleteGroup',[_dec],Object.getOwnPropertyDescriptor(_class.prototype,'_deleteGroup'),_class.prototype)),_class));


module.exports=DeleteGroupModalController;
//# sourceMappingURL=deleteGroupModalController.js.map
